import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

export const AccountButtonStyleValues = {
  menuWidth: '14.5rem',
  menuMaxHeight: '70vh',
  chevronBoxSize: '1rem',
}

const AccountButtonStyleParts = ['leftIcon', 'rightIcon'] as const

const helpers = createMultiStyleConfigHelpers(AccountButtonStyleParts)
export const AccountButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    leftIcon: {
      boxSize: '1.25rem',
    },
    rightIcon: {
      boxSize: '0.75rem',
    },
  },
})

export const useAccountButtonStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(AccountButtonStyle, props) as MultiStyleType<
    typeof AccountButtonStyleParts
  >
}
